<template>
    <div class="payment__form">
        <form
            v-if="
                checkoutData.view.current == 'MOMO_FRANCO_INIT_VIEW' &&
                    checkoutData.processing != true
            "
            @submit.prevent="checkPhoneAndNetwork"
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("mm.init.instruction")}}
            </h5>
            <primary-select
                class="container__col-md-12 container__col-sm-12"
                :description-text="$t('ui.input.choose')"
                @value-change="country = $event"
                :options="state.country"
                :title="$t('mm.input.country')"
                inputName="country"
                :defaultValue="state.defaultCountry"
                :isRequired="getValueFromPath(state, 'inputs.country.required') || true"
            />
            <primary-select
                class="container__col-md-12 container__col-sm-12"
                :title="$t('mm.input.network')"
                :description-text="$t('ui.input.choose')"
                @value-change="network = $event"
                :options="state.networks"
                :defaultValue="state.defaultNetwork"
                :isRequired="getValueFromPath(state, 'inputs.network.required') || true"
                inputName="network"
            />
            <primary-input
                :title="$t('mm.input.phone')"
                type="tel"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                :placeholder="dynamicPlaceholder"
                :defaultValue="getValueFromPath(state, 'inputs.phone.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.phone.required') || true"
                @value-change="telephone = $event"
                inputName="phone"
                :number-only="true"
            />
            <primary-input
                :title="$t('mm.input.auth_code')"
                type="number"
                v-if="showAuthCodeInput"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="lock-icon"
                placeholder="534865"
                :defaultValue="getValueFromPath(state, 'inputs.authorization_code.value') || null"
                :isRequired="getValueFromPath(state, 'inputs.authorization_code.required') || true"
                @value-change="authorizationCode = $event"
                inputName="authorization_code"
                :number-only="true"
            />
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
                :disabled="hasCompletedFields === false"
            />
            <p class="auth_code_notice" v-if="showAuthCodeInput">
                {{ $t("mm.auth_code_instruction") }}
            </p>
        </form>
        <div
            v-else-if="
                state.currentView == 'MOMO_FRANCO_CONFIRM_VIEW' &&
                    state.processing != true
            "
        >
            <p
                v-html="instructions"
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            ></p>

            <div class="center">
                <div class="loader-icon"></div>
            </div>
            <p class="payment__instruction--refresh">{{$t("ui.transaction.refresh")}}.</p>
        </div>
        <div
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <div class="redirect-icon--arrow">
                    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.1799 3.13007L18.5799 7.10007L24.7999 6.47007L13.2599 20.5301L4.15988 13.1301L1.62988 16.2201L13.8299 26.1301L27.9799 8.89007L28.6199 15.2501L32.5999 14.8501L31.2799 1.82007L18.1799 3.13007Z" fill="#FFCA7D"/>
                        <path d="M17.0998 1.51996L17.4998 5.47996L23.7098 4.85996L12.1798 18.91L3.0898 11.52L0.549805 14.61L12.7498 24.52L26.8998 7.27996L27.5398 13.64L31.5198 13.24L30.1998 0.209961L17.0998 1.51996Z" fill="black"/>
                        <path d="M0.549805 14.61L1.6298 16.22L13.8298 26.13L12.7498 24.52L0.549805 14.61Z" fill="#703E00"/>
                        <path d="M17.5 5.47998L18.58 7.09999L22.18 6.72998L23.71 4.85999L17.5 5.47998Z" fill="#703E00"/>
                        <path d="M27.54 13.64L28.62 15.25L32.6 14.85L31.52 13.24L27.54 13.64Z" fill="#FFCA7D"/>
                        <path d="M30.1997 0.209961L31.2797 1.81996L32.5997 14.85L31.5197 13.24L30.1997 0.209961Z" fill="#703E00"/>
                    </svg>
                </div>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("mm.redirect.instruction")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </div>
        <div v-else-if="state.currentView == 'CONFIRMING_VIEW' && state.processing != true">
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("mm.confirming") }}
            </p>

            <div class="center">
                <div class="loader-icon"></div>
            </div>
        </div> 
    </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { getValueFromPath, getCodeFromString } from "@/support/helpers";
import PrimarySelect from "@/components/form/base-select";
import PrimaryButton from "@/components/form/base-button";
import PrimaryInput from "@/components/form/base-input";
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount, watch, computed } from "vue";
import defaultPhoneNumbers from "../../default-phone-numbers";
import { isValidPhoneNumber } from "../../support/helpers";

export default {
    name: "MobileMoneyFranco",
    components: {
        PrimaryInput,
        PrimaryButton,
        PrimarySelect,
    },
    setup(_, { emit }) {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const network = ref("");
        const telephone = ref("");
        const country = ref("");
        const authorizationCode = ref("");
        const transactionSuccessful = ref(false);
        const momoError = ref(false);
        const errorMessage = ref("");
        const { t } = useI18n();

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function checkPhoneAndNetwork() {
            if (country.value != "" && telephone.value != "") {
                let trimmedPhoneNumber = telephone.value.replace(/\s/g, "").replace(/[()]/g, "");

                if (isValidPhoneNumber(trimmedPhoneNumber)) {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = "";
                    telephone.value = trimmedPhoneNumber;
                    step2();
                } 
                else {
                    momoError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("mm.invalid.phonenumber");
                }
            }
        }
        watch(country, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                checkoutData.value.view.context.$actions.update({ country: newVal });
            }
        });

        watch(network, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                checkoutData.value.view.context.$actions.update({ network: newVal });
            }
        });

        const hasCompletedFields = computed(() => {
            let completed = false;
            if (telephone.value && network.value) {
                completed = true;
            }
            return completed;
        });

        watch(momoError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("momo-error", errorMessage.value);
            }
        });

        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                momoError.value = false;
            }
        });

        function step2() {
            const data = { network: network.value, phone: telephone.value };
            if (showAuthCodeInput.value) data["authorization_code"] = authorizationCode.value;
            checkoutData.value.view.context.$actions.update(data);
            Next();
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        const instructions = computed(() => {
            const instruction = getCodeFromString(
                checkoutData.value.view.context.instruction,
                "momo",
            );
            return instruction;
        });

        const showAuthCodeInput = computed(() => {
            if (country.value && network.value) {
                if (country.value.code === "BF" && network.value.identifier !== "mobicash") {
                    return true;
                }
            }
            return false;
        });

        // Doing this in-file because I couldn't find a way to get the value of the country input on the 
        // base-input component
        const dynamicPlaceholder = computed(() => {
            let placeholder = null;
            if (checkoutData.value.currency.current === "XOF") {
                const countrySelected = country.value.code;
                if (countrySelected) {
                    Object.entries(defaultPhoneNumbers).forEach(([key, value]) => {
                        if (key.includes(countrySelected)) {
                            placeholder = value;
                        }
                    });
                }
            }
            return placeholder;
        });

        onBeforeUnmount(() => {
            momoError.value = false;
            errorMessage.value = "";
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                defaultNetwork: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.value") || null,
                networks: (state) =>
                    getValueFromPath(state, "view.context.inputs.network.options") || [],
                country: (state) =>
                    getValueFromPath(state, "view.context.inputs.country.options") || [],
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instruction") || null,
                defaultCountry: (state) =>
                    getValueFromPath(state, "view.context.inputs.country.value"),
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            checkoutData,
            getValueFromPath,
            country,
            network,
            telephone,
            instructions,
            getCodeFromString,
            transactionSuccessful,
            checkPhoneAndNetwork,
            authorizationCode,
            step2,
            showAuthCodeInput,
            Next,
            hasCompletedFields,
            dynamicPlaceholder,
        };
    },
};
</script>

<style scoped>
    .auth_code_notice {
        margin-top: 12px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
    }
</style>